<vee-field v-slot="props" v-model="computedModelValue" :rules="rules" :name="name" :label="label || name"
    :validate-on-mount="validateOnMount">
    <div class="input-wrapper" :class="inputClass, { 'mt-input--error': bannedWordIsPresent }, {'showNormalErrorBorder' : (props?.errors?.length || errorExist)}, 'inputFieldClass',{ 'disabledFieldClass': disabled }">
        <MdTypography class="firstOptionalText" v-if="showFirstOptionalText" tag="span" color="spirits--600"
            variant="body2--regular" :style="{paddingTop: showPlaceholder ? '0.875rem' : '0'}">
            {{firstOptionalText}}
        </MdTypography>
        <MdIconSearch v-if="searchEnable" :color="disabled ? 'spirits--500' : 'spirits--600'"/>
        <input :id="id" :ref="`style ${refId}`" autocomplete="off" :data-qa-id="dataQaId" :accept="acceptType" :class="{
            placeholderInputField: showPlaceholder,
            withCounterInputField: showCounter
          }"
        :style="{ paddingLeft: showFirstOptionalText && firstOptionalText ? '0.25rem' : '1rem' }"
        :placeholder="placeholder" :disabled="disabled" :name="name" :type="type"
        v-bind="props?.field" :readonly="readOnly" :multiple="multiple" @blur="handleBlur" @focus="handleFocus" @keyup="keyUp"
        :maxlength="maxLength"
        @change="handleChange" @mouseover="mouseOver" @mouseout="mouseOut" @keydown="handleNumberInput" @keydown.enter.prevent="handleEnterKeyDown"  @keyup.enter.prevent="handleEnterKeyUp">

        <MdIconClose class="close-icon-new-text-field" v-if="modelValue && showCrossIcon" icontitle="disabled" color="spirits--600" as="button"
        @handleiconclick="onSearchCrossIconClick"></MdIconClose>

        <label :class="movePlaceHolder ? 'moveInputFieldLable' : 'inputFieldLabel'" :for="id" v-if="showPlaceholder">
            <MdTypography tag="span" color="spirits--600" :variant="movePlaceHolder ? 'micro2--regular' : 'body2--regular'">
                {{placeholderText}}
            </MdTypography>
        </label>
        <MdTypography class="optionalText"  v-if="showOptionalText" tag="span" color="spirits--700" variant="body2--regular">
            {{optionalText}}
        </MdTypography>
        <MdTypography class="counter"  v-if="computedModelValue.length > 0 && showCounter" tag="span" color="spirits--700" variant="micro1--regular">
            {{computedModelValue.length}}/{{maxLength}}
        </MdTypography>
    </div>
    <div v-show="props?.errors?.length && showErrorMessage && !bannedWordIsPresent &&!warningWordIsPresent" class="mt-error-wrapper" >
        <slot name="errorContent" :errors="props?.errors">
            <span v-for="(error, i) in props?.errors" :key="i" :class="['mt-error', errorClass]">
                {{ error }}
            </span>
        </slot>
    </div>
    <div v-if="bannedWordIsPresent && showBannedWordErrorMessage" class="mt-error" :class="errorClass">
        {{$t('pages.profile.foundry_profile.banned_word_error_message')}}
    </div>
    <div v-if="warningWordIsPresent && showWarningWordErrorMessage" class="mt-error warning" :class="warningClass">
        {{ $t('pages.profile.foundry_profile.warning_word_error_message', {words: warningWords.join('", "')}) }}
    </div>
</vee-field>
